
import EditorViewer from '@/_components/editorJS/viewer/viewer.vue'
import ProjectMixin from '@/_mixins/project'
import { Component, Prop, VModel } from 'vue-property-decorator'
import { getRequest } from '@/plugins/api-axios'
import { Mixins } from 'vue-mixin-decorator'
import { deserialise } from 'kitsu-core'
import FormCheckboxGroup from '@/views/Project/Form/components/formCheckboxGroup.vue'
import InlineUser from '@/views/User/components/inlineUser/inlineUser.vue'
import type MixinInterface from '@/_mixins'
import { Step } from '../viewModels/step'

@Component({
    mixins: [ProjectMixin],
    name: 'FormResponseViewer',
    components: {
        FormCheckboxGroup,
        EditorViewer,
        InlineUser,
    },
})
export default class FormResponseViewer extends Mixins<MixinInterface>(ProjectMixin) {
    @VModel() formResponse!: any
    @Prop() resourceFormResponse!: any

    response: any = this.formResponse ?? null
    isNotFound = false

    get languageId() {
        return this.response?.languageId
    }

    get revision() {
        return this.response?.revision?.data
    }

    get steps(): Step[] {
        if (!this.revision?.data?.steps) return []
        const stepList = this.revision.data.steps.map((step) => new Step(this.languageId, step))

        if (this.$scopedSlots['prepend-step-title']) {
            const lastStep = new Step(this.languageId)
            lastStep._type = 'prepend-step'
            stepList.push(lastStep)
        }

        return stepList
    }

    get inputIds() {
        if (!this.response?.inputData) return {}

        const ids: Record<string, true> = {}
        for (const key in this.response.inputData) {
            ids[key] = true
            this.response.inputData[key].selectedItems?.forEach((item) => {
                ids[item] = true
            })
        }

        return ids
    }

    async created() {
        if (!this.resourceFormResponse) {
            return
        }

        let { data } = await getRequest(
            `${this.formBaseUrl}/formResponses?skipLinks`,
            this.headersmixins,
            {
                'filter[resource]': this.resourceFormResponse.id,
                include: 'revision,resource',
            }
        )

        this.response = deserialise(data).data[0]
        this.isNotFound = !this.response
        this.$emit('load:formResponse', this.response)
    }
}
